import React, { useState } from "react";
import { colorPrimary } from "../../Styles/Colors";
import { Box, TextField, Typography, Snackbar, Alert } from "@mui/material";

const TextBox = ({
  label,
  variant,
  style = {},
  textStyle = {},
  validationRules = [],
  value: controlledValue,
  onChange: controlledOnChange,
}) => {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);

  // Helper to extract text from label (string or React element)
  const getLabelText = (lbl) => {
    if (typeof lbl === "string") return lbl;
    if (typeof lbl === "number") return String(lbl);
    if (Array.isArray(lbl)) return lbl.map(getLabelText).join(" ");
    if (React.isValidElement(lbl)) {
      // Handle React fragments
      if (lbl.type === React.Fragment && lbl.props && lbl.props.children) {
        return getLabelText(lbl.props.children);
      }
      // Handle other React elements
      if (lbl.props && lbl.props.children) {
        return getLabelText(lbl.props.children);
      }
      return "";
    }
    return "";
  };

  const validate = (val) => {
    const labelText = getLabelText(label) || "Field";
    for (const rule of validationRules) {
      if (rule.name && rule.name.toLowerCase().includes("required")) {
        if (!val || val.trim() === "") {
          return (
            rule.errorMessage?.replace("{field}", labelText) ||
            `${labelText} is required.`
          );
        }
      }
      if (rule.regex) {
        const re = new RegExp(rule.regex);
        if (val && !re.test(val)) {
          return (
            rule.errorMessage?.replace("{field}", labelText) ||
            `${labelText} is invalid.`
          );
        }
      }
    }
    return "";
  };

  const handleBlur = (e) => {
    const val = e.target.value;
    const err = validate(val);
    setError(err);
    setOpen(!!err);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  const handleChange = (e) => {
    if (controlledOnChange) {
      controlledOnChange(e);
    } else {
      setValue(e.target.value);
      console.log("TextBox value:", e.target.value);
      if (error) setError("");
    }
  };

  const mergedSx = {
    "& .MuiInputLabel-root": {
      color: textStyle.color || colorPrimary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: textStyle.color || colorPrimary,
      
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: style.borderColor || colorPrimary,
      },
      "&:hover fieldset": {
        borderColor: style.borderColor || colorPrimary,
      },
      "&.Mui-focused fieldset": {
        borderColor: style.borderColor || colorPrimary,
        borderWidth: style.borderWidth || "2px",
        
      },
      height: style.height , 
    },
  };

  return (
    <Box display={"flex"} width="100%" flexDirection="column" gap={0.5}>
      <TextField
        id="outlined-basic"
        label={label}
        variant={variant}
        sx={mergedSx}
        style={style}
        value={controlledValue !== undefined ? controlledValue : value}
        onChange={handleChange}
        onBlur={handleBlur}
        error={!!error}
      />
      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default TextBox;
